import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const deleteApplianceMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Delete appliance',
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ refMap, controller }): void => {
			// const refMap = controller?.kitchen?.getReferenceMap(appState.ui.pointer.context.ref.id);
			// console.log('menuitem:delete-appliance:handler', refMap)
			if (refMap && refMap.panelItem) {
				refMap.panelItemGroup.items.delete(refMap.panelItem.id);
			}
		}
	};
};
